var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,13.29V3.5a.5.5,0,0,0-.5-.5,10.5,10.5,0,0,0,0,21,10.4,10.4,0,0,0,7.42-3.08.48.48,0,0,0,0-.7ZM10.5,23A9.5,9.5,0,0,1,10,4V13.5a.47.47,0,0,0,.15.35l6.71,6.71A9.43,9.43,0,0,1,10.5,23Zm13-11h-10a.5.5,0,0,0-.46.31.47.47,0,0,0,.11.54l7.07,7.07a.49.49,0,0,0,.35.15.47.47,0,0,0,.35-.15A10.38,10.38,0,0,0,24,12.5.5.5,0,0,0,23.5,12Zm-2.94,6.85L14.71,13H23A9.37,9.37,0,0,1,20.56,18.85ZM13.5,11h10a.5.5,0,0,0,.5-.5A10.51,10.51,0,0,0,13.5,0a.5.5,0,0,0-.5.5v10A.5.5,0,0,0,13.5,11ZM14,1a9.53,9.53,0,0,1,9,9H14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechart);
export default __webpack_public_path__ + "static/media/piechart.091cc63370dc5b464593ef9479a63676.svg";
export { ForwardRef as ReactComponent };